import workflowAutomationImage from '../assets/projects/workflow-automation.webp';
import nicetStudyImage from '../assets/projects/nicetstudy-logo.webp';
import lifeSafetyAiImage from '../assets/projects/lifesafetyai.webp';
import aileronPlatformImage from '../assets/projects/aileronsys.webp';

const projects = [
  {
    id: 'lifesafetyai',
    title: 'LifeSafetyAI',
    type: 'initiative',
    shortDescription: 'A community and education-focused initiative sharing practical AI guidance for life safety and operational teams.',
    category: 'Community Initiative',
    audience: 'Life safety professionals, operations teams, and service organizations',
    focus: 'Education, resource sharing, and real-world workflow guidance',
    mission: 'Help teams adopt modern AI-enabled practices responsibly and effectively.',
    image: lifeSafetyAiImage,
    status: 'Active Initiative',
    ctaLabel: 'Visit LifeSafetyAI',
    ctaUrl: 'https://lifesafetyai.com',
    aileronRelation: 'Aligned with Aileron Systems for advisory, implementation, and strategy support.',
  },
  {
    id: 'workflow-automation',
    title: 'Workflow Automation Toolkit',
    type: 'product',
    shortDescription: 'Custom automation pipelines for reducing manual operational work.',
    category: 'Automation',
    industry: 'Trade Businesses / Service Companies',
    stack: ['Python', 'React', 'PHP APIs'],
    problemSolved: 'Eliminates bottlenecks in repetitive scheduling, reporting, and updates.',
    image: workflowAutomationImage,
    status: 'Client-Focused',
    ctaLabel: 'Explore Through Aileron Systems',
    ctaUrl: 'https://aileronsys.com',
    aileronRelation: 'Delivered as part of Aileron Systems implementation engagements.',
  },

  {
    id: 'aileron-platform',
    title: 'Aileron Platform',
    type: 'product',
    shortDescription: 'A fully customizable ERP platform built for the service and construction industries.',
    category: 'ERP (operations)',
    industry: 'Trade Businesses / Service Companies',
    stack: ['ERP Modules', 'Scheduling', 'Inspections', 'Accounting'],
    problemSolved: 'Connects scheduling, inspections, service calls, maintenance tracking, and accounting into one streamlined operating platform.',
    image: aileronPlatformImage,
    status: 'Platform',
    ctaLabel: 'Visit Aileron',
    ctaUrl: 'https://aileronsys.com',
    aileronRelation: 'Built to digitize, automate, and elevate trade company operations with practical field-ready workflows and connected digital systems.',
  },

  {
    id: 'nicetstudy',
    title: 'NICETStudy',
    type: 'product',
    shortDescription: 'Exam preparation tools and study resources designed for technicians pursuing NICET certification.',
    category: 'Education / Certification',
    industry: 'Fire Alarm & Life Safety',
    stack: ['React', 'PHP', 'MySQL'],
    problemSolved: 'Helps technicians prepare for NICET exams through practice tests, study guides, and curated learning resources.',
    image: nicetStudyImage,
    status: 'Learning Platform',
    ctaLabel: 'Explore NICETStudy',
    ctaUrl: '/contact',
    aileronRelation: 'Supports workforce development and professional growth within the life safety industry.',
  },
];

export default projects;
